import React from 'react';

/* WithInfo Screen */
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { FrameAction } from '../../..//redux/slice/frame/root_main_slice';
import { Com0103mAction } from '../../..//redux/slice/com/com0103m_slice';

import { Layout, Breadcrumb, Space, Row, Col } from 'antd';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import * as component from 'libs/components';

import { Routes, Route } from 'react-router';


const WithInfoContents = () => {
    const dispatch = useAppDispatch();
    const allLnbMenuItems = useAppSelector((state) => state.Frame.allLnbMenuItems);
    const lnbCollapsed    = useAppSelector((state) => state.Frame.lnbCollapsed);
    const activeKey       = useAppSelector((state) => state.Frame.activeKey);
    const menuPath        = useAppSelector((state) => state.Frame.menuPath);
    const activeProps     = useAppSelector((state) => state.Frame.activeProps);

    const [contentHeight, setContentHeight] = React.useState<number>(window.innerHeight);

    const routeItem = React.useCallback(() => {
        let rtn = null;

        let tmpActiveKey = activeKey ? activeKey : 'MCOM2021006';

        let menuItem:any = allLnbMenuItems.filter((tab:any) => tab.key === tmpActiveKey)[0];
        let pgmPath:string = menuItem.pgmId;
        let props = {pgmPath:pgmPath, props : activeProps };
        
        dispatch(Com0103mAction.setBoardDcd(menuItem.relVal));

        rtn = component.fn_getComponent(props);

        return rtn;
    }, [activeKey]);

    React.useEffect(() => {
        const updateHeight = () => {
            const headerHeight = 125;  // Header 높이
            setContentHeight(window.innerHeight - headerHeight);
        };
      
        window.addEventListener('resize', updateHeight);
        updateHeight();

        return () => {
            document.body.classList.remove('fixed');
            window.removeEventListener('resize', updateHeight);  // 클린업
        };
    });


    const toggle = () => {
        dispatch(FrameAction.setLnbCollapsed(!lnbCollapsed));
        dispatch(FrameAction.setLnbWidth(lnbCollapsed ? '200' : '0'));
    };

    return ( 
        <Layout style={{ margin: "2px", padding: '0 10px 24px', borderRadius: "0.5em", backgroundColor: "white" }}>
            <Row>
                <Col flex='1'>
                    <Breadcrumb style={{ margin: '5px 0' }}>
                        <Space>
                            {React.createElement(lnbCollapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                            className: 'trigger',
                            onClick: toggle,
                            })}
                            {menuPath}
                        </Space>
                    </Breadcrumb>
                </Col>
            </Row>
            <Row>
                <Col flex='1'>
                <div style={{ flex: '1 1 auto', height : contentHeight, overflowY: 'auto'}}>
                    <Routes>
                        <Route key={activeKey} path={'/' + activeKey} element={routeItem()} />
                    </Routes>
                </div>
                </Col>
            </Row>
        </Layout>   
    );

}

export default WithInfoContents;